export default __webpack_public_path__ + "static/media/big-add-item.5369c539.svg";